import { AnyAction } from "redux";
import * as AT from "./actionTypes";
import { ClientSideConfig } from "../../../../models";

const configReducer = (state: Partial<ClientSideConfig> = {}, action: AnyAction) => {
    switch (action.type) {
        case AT.CONFIG_INITIALIZE_CONFIG:
            return action.value;
        case AT.CONFIG_SET_APPEARANCE:
            return state.appearance === action.value ? state : { ...state, appearance: action.value };
        case AT.CONFIG_SET_SYSTEM_APPEARANCE:
            return state.systemAppearance === action.value ? state : { ...state, systemAppearance: action.value };
        default:
            return state;
    }
};

export default configReducer;
